import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/appSettings';

@Injectable()
export class UserManagementService {
  readonly rootUrl = AppSettings.webApiURL; 

  constructor(public httpClient: HttpClient) { }

  public getSearchUsers(search) {
    return this.httpClient.get(`${this.rootUrl}/api/UserManagementApi/GetSearchUsers?search=${search}`);
  }

  public getUser(id) {
    return this.httpClient.get(`${this.rootUrl}/api/UserManagementApi/GetUser?id=${id}`);
  }

  public getRoleDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/UserManagementApi/GetRoles`);
  }

  public getOrganizationUnitDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/UserManagementApi/GetOrganizationUnits`);
  }

  // public getListCustomerDDL() {
  //   return this.httpClient.get(`${this.rootUrl}/api/UserManagementApi/GetListCustomerDDL`);
  // }
  // public getCustomerByUser(id) {
  //   return this.httpClient.get(`${this.rootUrl}/api/UserManagementApi/GetCustomerByUserIdDDL?id=${id}`);
  // }

  public updateUser(user) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.put(`${this.rootUrl}/api/UserManagementApi/PutUser`, user, { headers });
  }

  public insertUser(user) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/UserManagementApi/PostUser`, user, { headers });
  }

  downloadLogFile() {
    // const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.get(`${this.rootUrl}/api/UserManagementApi/downloadLogFile`,{ responseType: 'blob' });
  }
  downloadYesterdayLogFile() {
    // const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.get(`${this.rootUrl}/api/UserManagementApi/downloadYesterdayLogFile`,{ responseType: 'blob' });
  }

  public getCustomers() {
    return this.httpClient.get(`${this.rootUrl}/api/UserManagementApi/GetCustomers`);
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/service/user-management.service.ts